module.exports = __webpack_public_path__ + "media/images/shared/delivery/dl-7d1abc8c49640799e638abefd5a0fc12.jpg";